import _ from 'lodash-es';
import {
  core,
  getLayoutVars,
  getGrid,
  getTitle,
  getSiblingOption,
} from './default';
import { getMetrics, computeCore, createLink } from './common';

const gaugeCore = {
  layout: {
    ...core.layout,
    gauge: {
      center: function({ size, spacing, x, y }, meta, instance) {
        let relativeCenter = getSiblingOption(
          instance,
          meta,
          'relativeCenter',
          ['50%', '50%']
        );
        relativeCenter = relativeCenter.map((c) =>
          parseFloat(c.replace('%', ''))
        );

        const gridRight = parseFloat(
          gaugeCore.layout.grid
            .right({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridLeft = parseFloat(
          gaugeCore.layout.grid
            .left({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridWidth = 100 - gridRight - gridLeft;

        const gridBottom = parseFloat(
          gaugeCore.layout.grid
            .bottom({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridTop = parseFloat(
          gaugeCore.layout.grid
            .top({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridHeight = 100 - gridBottom - gridTop;

        const gridCenter = [gridLeft + gridWidth / 2, gridTop + gridHeight / 2];

        return [
          gridCenter[0] + (gridWidth * (relativeCenter[0] - 50)) / 100 + '%',
          gridCenter[1] + (gridHeight * (relativeCenter[1] - 50)) / 100 + '%',
        ];
      },
      radius: function({ size, spacing, x, y }, meta, instance) {
        let relativeRadius = getSiblingOption(
          instance,
          meta,
          'relativeRadius',
          '100%'
        );
        relativeRadius = parseFloat(relativeRadius.replace('%', '')) / 100;
        const gridRight = parseFloat(
          gaugeCore.layout.grid
            .right({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridLeft = parseFloat(
          gaugeCore.layout.grid
            .left({ size, spacing, x }, meta, instance)
            .replace('%', '')
        );

        const gridBottom = parseFloat(
          gaugeCore.layout.grid
            .bottom({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );

        const gridTop = parseFloat(
          gaugeCore.layout.grid
            .top({ size, spacing, y }, meta, instance)
            .replace('%', '')
        );
        const gridWidth = 100 - gridRight - gridLeft;
        const gridHeight = 100 - gridBottom - gridTop;
        return relativeRadius * Math.max(gridWidth, gridHeight) + '%';
      },
    },
  },
};

function getGaugeVars(sample, size) {
  const {
    radius,
    center: [centerX, centerY],
  } = sample.series[0];
  return {
    ...getLayoutVars(size),
    gauge: {
      relativeRadius: radius,
      relativeCenter: [centerX, centerY],
    },
  };
}

function getGauge(arg, vars, core) {
  return {
    center: createLink({ ...arg, path: 'layout.gauge.center' }, vars, core),
    radius: createLink({ ...arg, path: 'layout.gauge.radius' }, vars, core),
    relativeCenter: createLink('layout.gauge.relativeCenter', vars),
    relativeRadius: createLink('layout.gauge.relativeRadius', vars),
  };
}

export default {
  compute: (...args) => computeCore(gaugeCore, ...args),
  sample: function(sample, template, size) {
    const m = getMetrics(size);

    if (m.cols == 1 && m.rows == 1) {
      return sample;
    }

    if (!sample.vars) {
      sample.vars = {};
    }

    sample.vars.layout = getGaugeVars(sample, size);
    const vars = sample.vars;

    sample.chartName = `Multi-Gauge ${m.cols}x${m.rows}`;
    sample.aspectRatio = `${m.cols}:${m.rows}`;

    if (sample.legend) {
      sample.legend.show = false;
    }

    const serie = sample.series[0];
    sample.series = [];

    const title = sample.title[0];
    sample.title = [];

    const grid = (sample.grid && sample.grid[0]) || {};

    sample.grid = [];

    for (let x = 0; x < m.cols; x++) {
      for (let y = 0; y < m.rows; y++) {
        const arg = { x, y, size, type: 'gauge' };

        const g = getGrid(arg, vars, gaugeCore);
        const dx = g.right;
        const dy = 100 / m.rows;

        const dmin = Math.min(dx, dy);
        sample.grid.push({
          ...grid,
          ...g,
        });

        let s = {
          ...serie,
          type: 'multigauge',
          originalType: 'gauge',
          name: `${template}-${x + 1}-${y + 1}`,
          ...getGauge(arg, vars, gaugeCore),
        };
        s.detail.fontSize = `${Math.max(dmin / 2, 10)}`;
        s.title.fontSize = `${Math.max(dmin / 2, 10)}`;

        sample.series.push(s);

        sample.title.push({
          ...title,
          ...getTitle(arg, vars, gaugeCore),
          text: `${x + 1}-${y + 1}`,
        });
      }
    }

    return sample;
  },
};
